module.exports = __webpack_public_path__ + "img/germany-tuberculosis-female.99569f21.png";